var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-jst-picker',_vm._g(_vm._b({attrs:{"url":_vm.terytUrl}},'w-jst-picker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }